import { customGetQuote } from "@iewccouk/Services/CustomQuoteGuestService";
import loadQuote from "@iewccouk/Store/Handlers/Quotes/LoadQuoteDetails";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getQuote } from "@insite/client-framework/Services/QuoteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import { chain as qyoteDetailChain, DispatchLoadQuoteIfNeeded } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/LoadQuoteIfNeeded";

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        // Verndale Customization: We call a custom api for all quotes created by guests or users
        // This api will request the quote as an "order" in the backend, since this project doesn't use the "quote" functionality
        props.apiResult = await customGetQuote(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/Quotes/FailedToLoadQuote",
                quoteId: props.parameter.quoteId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
});

replaceInChain(qyoteDetailChain, DispatchLoadQuoteIfNeeded, props => {
    const quoteState = getQuoteState(props.getState(), props.parameter.quoteId);
    if (!quoteState.value || !quoteState.value.quoteLineCollection) {
        props.dispatch(loadQuote({ quoteId: props.parameter.quoteId }));
    }
});
